import React, { useEffect, useState } from "react";
import { getDocs } from "firebase/firestore";
import { keepersReference, currYear } from "./App";
import keepers from "./keepers.json";

export default function StatsKeepers({ nameIdArr = [] }) {
  const [selections, setSelections] = useState(null);
  const [error, setError] = useState(false);
  useEffect(() => {
    let active = true;
    getDocs(keepersReference).then(snapshot => {
      if (active) setSelections(snapshot.docs.map(doc => doc.data()).filter(item => item.Year === currYear));
    }).catch(() => { if (active) setError(true); });
    return () => { active = false; };
  }, []);
  return <section className="keeper-stats">
    <div className="stats-section-heading"><h2>League keepers</h2><span className="keeper-season">{currYear} season</span></div>
    <p className="stats-context">The players each team is bringing back. Round labels show their keeper cost.</p>
    {error ? <p role="alert">Keeper selections could not be loaded. Refresh to try again.</p> : !selections ? <p role="status">Loading keepers…</p> :
      <div className="keeper-roster-grid">{nameIdArr.map(([id, name]) => {
        const selected = selections.find(item => item.Uid === id);
        const pool = keepers.find(item => item.id === id && item.year === currYear);
        return <article className="keeper-roster" key={id}><h3>{name}</h3><div className="keeper-slots">{['K1', 'K2'].map((slot, index) => {
          const player = selected?.[slot];
          const round = pool?.players.find(item => item.player === player)?.round;
          return <div className={`keeper-slot ${player ? '' : 'keeper-slot-empty'}`} key={slot}><span className="keeper-slot-label">Keeper {index + 1}</span><strong>{player || 'Not selected'}</strong>{player && round != null && <span className="keeper-round">Round {round}</span>}</div>;
        })}</div></article>;
      })}</div>}
  </section>;
}
